export interface IEventSessionState {
  index: number;
  customer_id: string;
  options?: { name: string; value: string }[];
  phone: string;
  instagram: string;
  email: string;
  eventStatus: string;
  imageUrl: string;
  handle: string;
  title: string;
  type?: string;
  page: string;
}

const initialStateOrders: IEventSessionState[] = [];

const UPDATE_EVENT_SESSION = "SESSION/UPDATE_EVENT_SESSION" as const;

export const eventSession = (state = initialStateOrders, action: EventSessionAction) => {
  switch (action.type) {
    case UPDATE_EVENT_SESSION:
      return [...action.eventSession];
    default:
      return state;
  }
};

type EventSessionAction = ReturnType<typeof updateEventSession>;

const updateEventSession = (eventSession: IEventSessionState[]) => ({ type: UPDATE_EVENT_SESSION, eventSession });

export const eventSessionCreator = {
  updateEventSession,
};
